import { useMemo } from 'react'
import { useBuyNowCouponDispatch } from '../contexts/buyNowCoupon.context'
import BuyNowActionNames from '../actions/buyNow.actions'

const {
  CLEAR_BUYNOW,
  ADD_BUYNOW,
} = BuyNowActionNames

const useBuyNowCouponController = () => {
  const dispatch = useBuyNowCouponDispatch()
  return useMemo(
    () => ({
      addBuyNowCoupon: buynow => {
        dispatch({ type: ADD_BUYNOW, payload: buynow })
      },
      clearBuyNowCoupon: () => dispatch({ type: CLEAR_BUYNOW, payload: {} }),
    }),
    [dispatch],
  )
}

export default useBuyNowCouponController
